"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @param {number} companyId A reference to a single company
 * @class CompaniesBank
 * @classdesc Handles a companies bank details
 */
var CompaniesBank = /** @class */ (function () {
    function CompaniesBank(recover, companyId) {
        var _this = this;
        this.recover = recover;
        this.companyId = companyId;
        /**
         *
         *
         * @memberof CompaniesBank
         * @returns {SuccessfulGetBankDetails} Returns a message and the bank details of a single company
         * @description Gets the bank details of a single company
         */
        this.get = function () {
            return _this.recover.request("/companies/" + _this.companyId + "/bank_details", 'GET', null, null);
        };
        /**
         *
         *
         * @memberof CompaniesBank
         * @returns {SuccessfulPutBankDetails} Returns a message and the updated bank details}
         * @property {IBankDetails} bank_details A JSON containing any of the following fields; bank_name(string), bank_sort_code(string), bank_account_number(string), bank_account_holder(string)
         * @description Updates a companies bank details
         */
        this.update = function (bank_details) {
            return _this.recover.request("/companies/" + _this.companyId + "/bank_details", 'PUT', bank_details, null);
        };
    }
    return CompaniesBank;
}());
exports.default = CompaniesBank;
